import React, { useEffect, useCallback, useState} from 'react';
import MidiInput from './MidiInput.js';
import MidiOutput from './MidiOutput.js';
import {connect} from 'react-redux';

const Midi = ({sequencerEngine}) => { 
    let midiEngine = sequencerEngine.midi;
    let [syncedInput, setSyncedInput] = useState(midiEngine.systemInput);
    let [syncedOutput, setSyncedOutput] = useState(midiEngine.systemOutput);
    let inputs = midiEngine.getInputs();
    let outputs = midiEngine.getOutputs();
 
    return (
        <div className="midi-settings">
          <div className="midi-header">
            Input:
          </div>
          {inputs.map(
              x =>
                  <MidiInput
                    midiEngine={midiEngine}
                    syncedInput={syncedInput}
                    setSyncedInput={setSyncedInput}
                    input={x}/>)}
          <div className="midi-header">
            Output:
          </div>
          {outputs.map(
              x =>
                  <MidiOutput
                    midiEngine={midiEngine}
                    syncedOutput={syncedOutput}
                    setSyncedInput={setSyncedOutput}
                    output={x}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Midi);
